export default {
  CREATE: `Create a schedule type`,
  DELETE_BUTTON: {
    TITLE: `Delete the schedule type`,
    SUMMARY: `Are you sure you want to delete this schedule type?`,
    PRIMARY_ACTION: `Delete the schedule type`
  },
  LIST: {
    TITLE: `Schedule type list`,
    SUMMARY: ``
  },
  END_TIME: `End`,
  START_TIME: `Start`,
  TEAMS: `Teams`,
  SEARCH_RANGE: `Advanced filtering`,
  START_TIME_RANGE: `Range start`,
  END_TIME_RANGE: `Range end`,
  CSV_EXPORT_NAME: `scheduletypes_export_{{date}}`,
  form: {
    CREATE: {
      TITLE: `Creating a schedule type`,
      SUMMARY: ``
    },
    EDIT: {
      TITLE: `Editing a schedule type`,
      SUMMARY: ``
    },
    NAME: {
      LABEL: `Schedule type name`,
      DESCRIPTION: `This name should help you quickly identify the attribute.`,
      PLACEHOLDER: `Enter a name for the schedule type`
    },
    STARTTIME: {
      LABEL: `Schedule type start time`,
      DESCRIPTION: `The start time must be entered in a 24 hour format.`,
      PLACEHOLDER: `Enter the schedule type start time`
    },
    ENDTIME: {
      LABEL: `Schedule type end time`,
      DESCRIPTION: `The start time must be entered in a 24 hour format.`,
      PLACEHOLDER: `Enter the schedule type end time`
    },
    SEARCHRANGE: {
      LABEL: `Use this schedule type only for advanced filtering`,
      DESCRIPTION: `This will allow you to set a shift start range and a shift end range. This filter will then allow you to display all the shift that start in this range.`
    },
    STARTRANGESTARTTIME: {
      LABEL: `Beginning of the start time range`,
      DESCRIPTION: `The start time range start must be entered in a 24 hour format.`
    },
    STARTRANGEENDTIME: {
      LABEL: `End of the start time range`,
      DESCRIPTION: `The start time range end must be entered in a 24 hour format.`
    },
    DEPARTMENTS: {
      LABEL: `Department`,
      DESCRIPTION: `Departments of the schedule type`
    },
    NAME_REQUIRED: `Schedule type's name is mandatory.`,
    HOUR_REQUIRED: `The début et la fin est requis.`
  }
}
